import React, { useState } from 'react';
import { HistoricalEvent } from '../../services/timeTunnelService';
import './TimeTunnel.css';

interface EventListProps {
  events: HistoricalEvent[];
  selectedYear: number | null;
  selectedMonth: number | null;
  selectedDay: number | null;
  selectedCountry: string | null;
  onEdit: (event: HistoricalEvent) => void;
  onDelete: (eventId: number) => void;
}

const EventList: React.FC<EventListProps> = ({
  events,
  selectedYear,
  selectedMonth,
  selectedDay,
  selectedCountry,
  onEdit,
  onDelete
}) => {
  const formatDate = (event: HistoricalEvent) => {
    const parts: string[] = [];
    if (event.year) parts.push(event.year.toString());
    if (event.month) {
      const monthName = new Date(2000, event.month - 1).toLocaleString('default', { month: 'long' });
      parts.push(monthName);
    }
    if (event.day) parts.push(event.day.toString());
    return parts.join(' ');
  };

  const getFilterDescription = () => {
    const parts: string[] = [];
    if (selectedYear) parts.push(`Year: ${selectedYear}`);
    if (selectedMonth) {
      const monthName = new Date(2000, selectedMonth - 1).toLocaleString('default', { month: 'long' });
      parts.push(`Month: ${monthName}`);
    }
    if (selectedDay) parts.push(`Day: ${selectedDay}`);
    if (selectedCountry) parts.push(`Country: ${selectedCountry}`);
    return parts.length > 0 ? parts.join(', ') : 'All events';
  };

  const renderEventItem = (event: HistoricalEvent) => (
    <div key={event.id} className="event-list-item">
      <div className="event-list-item-header">
        <div className="event-list-item-date">{formatDate(event)}</div>
        <div className="event-list-item-country">{event.country}</div>
        <div className="event-list-item-actions">
          <button
            onClick={() => onEdit(event)}
            className="event-list-item-edit-btn"
            title="Edit"
          >
            ✏️
          </button>
          <button
            onClick={() => onDelete(event.id)}
            className="event-list-item-delete-btn"
            title="Delete"
          >
            🗑️
          </button>
        </div>
      </div>
      <div className="event-list-item-title">{event.title}</div>
      {event.description && (
        <div className="event-list-item-description">{event.description}</div>
      )}
    </div>
  );

  if (events.length === 0) {
    return (
      <div className="event-list-container">
        <div className="event-list-header">
          <h3>Events</h3>
          <span className="event-list-filter">{getFilterDescription()}</span>
        </div>
        <div className="event-list-empty">
          <p>No events found{selectedYear ? ` for ${selectedYear}` : ''}.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="event-list-container">
      <div className="event-list-header">
        <h3>Events ({events.length})</h3>
        <span className="event-list-filter">{getFilterDescription()}</span>
      </div>

      <div className="event-list">
        {events.map(event => renderEventItem(event))}
      </div>
    </div>
  );
};

export default EventList;

